import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterdata'
})
export class FilterPipe implements PipeTransform {

	transform(items: any[], value: string): any[] {
		if (!items) return [];
		if (!value) return  items;
		if (value === '' || value === null) return [];
		return items.filter(e => 
		e.NOMBRE.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
		(e.TELEFONO?e.TELEFONO:'').toLowerCase().indexOf(value.toLowerCase()) > -1 ||
		e.IDCASO.toString().toLowerCase().indexOf(value.toLowerCase()) > -1 
		);
	}

}
